import React from 'react';

const CircleIcon = (props) => (
  <svg {...props} width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4.5" r="4" fill="currentColor" />
  </svg>
);

export default CircleIcon;
